document.addEventListener("DOMContentLoaded", function () {
  initializeShopifyFormatMoney();
  handleMcMainProductImagesCarousel();
  handleMcMainProductAddToCart();
  handleMcMainProductVariantSelector();
});

// Expose functions globally for manual initialization
window.handleMcMainProductImagesCarousel = handleMcMainProductImagesCarousel;
window.handleMcMainProductAddToCart = handleMcMainProductAddToCart;
window.handleMcMainProductVariantSelector = handleMcMainProductVariantSelector;

/**
 * Handles product image carousel with Swiper.js
 * Stores the main swiper instance on the element for external access.
 * @param {HTMLElement} container - The container to scope the query selectors to
 */
function handleMcMainProductImagesCarousel(container = document) {
  const mainSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--main",
  );
  const thumbnailSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--thumbs",
  );
  const nextButton = container.querySelector(".mc-main-product-slider__next");
  const prevButton = container.querySelector(".mc-main-product-slider__prev");

  if (!mainSwiperElement) {
    console.warn("Main swiper element not found.");
    return;
  }

  // Initialize thumbnail swiper if it exists
  var thumbnailSwiper = null;
  if (thumbnailSwiperElement) {
    thumbnailSwiper = new Swiper(thumbnailSwiperElement, {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });
  }

  // Build main swiper configuration
  var mainSwiperConfig = {
    spaceBetween: 10,
  };

  // Add navigation if buttons exist
  if (nextButton && prevButton) {
    mainSwiperConfig.navigation = { nextEl: nextButton, prevEl: prevButton };
  }

  // Add thumbs if thumbnail swiper was initialized
  if (thumbnailSwiper) {
    mainSwiperConfig.thumbs = { swiper: thumbnailSwiper };
  }

  var mainSwiper = new Swiper(mainSwiperElement, mainSwiperConfig);

  // Store the swiper instance on the DOM element so variant selector can access it
  mainSwiperElement._swiperInstance = mainSwiper;
}

/**
 * Manages add to cart functionality with loading states and cart drawer updates
 */
function handleMcMainProductAddToCart(container = document) {
  var elements = {
    plusBtn: container.querySelector(".mc-main-product__quantity-plus"),
    minusBtn: container.querySelector(".mc-main-product__quantity-minus"),
    quantityInput: container.querySelector(".mc-main-product__quantity-input"),
    form: container.querySelector('form[data-type="add-to-cart-form"]'),
    submitBtn: container.querySelector(".mc-main-product__add-to-cart"),
    cartDrawer: document.querySelector("cart-drawer"),
  };

  if (!Object.values(elements).every(Boolean)) {
    console.warn(
      "Required elements for add to cart functionality are missing.",
    );
    return;
  }

  // Quantity Controls
  elements.plusBtn.addEventListener("click", function () {
    updateQuantity(1);
  });
  elements.minusBtn.addEventListener("click", function () {
    updateQuantity(-1);
  });

  function updateQuantity(change) {
    var currentQuantity = parseInt(elements.quantityInput.value) || 1;
    var newQuantity = Math.max(1, currentQuantity + change);
    elements.quantityInput.value = newQuantity;
  }

  // Add to Cart with Loading States
  elements.form.addEventListener("submit", async function (e) {
    e.preventDefault();

    var originalText = elements.submitBtn.textContent;

    try {
      setLoadingState(true, "ADDING TO CART...");

      var response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(elements.form),
      });

      var data = await response.json();

      if (data && data.id) {
        await updateCartDrawer();
        setLoadingState(false, "ADDED TO CART!");

        setTimeout(function () {
          elements.submitBtn.textContent = originalText;
        }, 2000);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      setLoadingState(false, "ERROR - TRY AGAIN");

      setTimeout(function () {
        elements.submitBtn.textContent = originalText;
      }, 3000);
    }
  });

  function setLoadingState(isLoading, text) {
    elements.submitBtn.disabled = isLoading;
    elements.submitBtn.textContent = text;
    elements.submitBtn.classList.toggle("loading", isLoading);
  }

  async function updateCartDrawer() {
    try {
      var response = await fetch("/?section_id=cart-drawer");
      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var newCartDrawer = doc.querySelector("cart-drawer");

      if (newCartDrawer && elements.cartDrawer) {
        elements.cartDrawer.innerHTML = newCartDrawer.innerHTML;
        elements.cartDrawer.classList.remove("is-empty");
        elements.cartDrawer.classList.add("active");

        if (typeof elements.cartDrawer.open === "function") {
          elements.cartDrawer.open();
        }
      }
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }
}

/**
 * Handles variant selection using multiple option dropdowns.
 * Finds the matching variant by combining selected options,
 * updates the hidden variant ID input, URL, price, image slider, and add-to-cart button.
 */
function handleMcMainProductVariantSelector(container = document) {
  var optionSelects = container.querySelectorAll(
    ".mc-main-product__option-select",
  );
  var variantIdInput = container.querySelector(
    ".mc-main-product__variant-id-input",
  );
  var variantDataScript = container.querySelector(
    ".mc-main-product__variant-data",
  );

  // Determine if this is a DFW product from the data attribute
  var productContainer = container.querySelector(".mc-main-product");
  var isDfw = false;
  if (productContainer) {
    isDfw = productContainer.getAttribute("data-is-dfw") === "true";
  }

  // Handle products with multiple option selects
  if (optionSelects.length > 0 && variantDataScript) {
    var variants = [];
    try {
      variants = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error("Failed to parse variant data:", e);
      return;
    }

    // Listen for changes on each option dropdown
    optionSelects.forEach(function (select) {
      select.addEventListener("change", function () {
        onOptionChange(variants);
      });
    });

    // Trigger initial selection
    onOptionChange(variants);
  } else if (!optionSelects.length) {
    // Handle products with single variant (no selector)
    handleSingleVariantProduct();
  }

  /**
   * Called whenever any option dropdown changes.
   * Finds the matching variant and updates all UI.
   */
  function onOptionChange(variants) {
    // Build selected options array from each dropdown
    var selectedOptions = [];
    optionSelects.forEach(function (select) {
      selectedOptions.push(select.value);
    });

    // Find matching variant
    var matchedVariant = variants.find(function (variant) {
      return variant.options.every(function (opt, index) {
        return opt === selectedOptions[index];
      });
    });

    if (matchedVariant) {
      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }

      updateURL(matchedVariant.id);
      updatePriceDisplays(matchedVariant);
      updateAddToCartButton(matchedVariant, isDfw);
      updateImageSlider(matchedVariant);
    }
  }

  /**
   * Handles products with only one variant (no variant selector)
   */
  async function handleSingleVariantProduct() {
    try {
      var productHandle = window.location.pathname.split("/").pop();
      var response = await fetch("/products/" + productHandle + ".js");
      var productData = await response.json();

      // Get the first (and only) variant
      var defaultVariant = productData.variants[0];

      if (defaultVariant) {
        updateURL(defaultVariant.id);
        updatePriceDisplays(defaultVariant);
        updateAddToCartButton(defaultVariant, isDfw);
      }
    } catch (error) {
      console.error("Error updating single variant:", error);
    }
  }

  /**
   * Updates browser URL with selected variant ID
   * @param {string} variantId - The selected variant ID
   */
  function updateURL(variantId) {
    var url = new URL(window.location);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url);
  }

  /**
   * Updates price displays based on selected variant
   * @param {Object} variant - The selected variant object
   */
  function updatePriceDisplays(variant) {
    var priceElement = container.querySelector(
      ".mc-main-product__price-current",
    );
    if (priceElement) {
      priceElement.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    }

    var compareAtPriceElement = container.querySelector(
      ".mc-main-product__price-compare",
    );

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = formatMoneyWithoutTrailingZeros(
          variant.compare_at_price,
        );
        compareAtPriceElement.style.display = "inline";
        compareAtPriceElement.classList.remove("hidden");
      }
    } else {
      if (compareAtPriceElement) {
        compareAtPriceElement.style.display = "none";
        compareAtPriceElement.classList.add("hidden");
      }
    }

    var priceElements = container.querySelectorAll("[data-product-price]");
    priceElements.forEach(function (element) {
      element.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    });
  }

  /**
   * Updates add to cart button state based on variant availability.
   * If the product has the DFW tag, we never disable the button.
   * @param {Object} variant - The selected variant object
   * @param {boolean} isDfwProduct - True if the product has DFW tag
   */
  function updateAddToCartButton(variant, isDfwProduct) {
    var addToCartBtn = container.querySelector(".mc-main-product__add-to-cart");
    if (addToCartBtn) {
      if (variant.available || isDfwProduct) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "ADD TO CART";
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = "SOLD OUT";
      }
    }
  }

  /**
   * Slides the main image carousel to the variant's featured media.
   * Uses two matching strategies:
   *   1. Match by featured_media_id (data-media-id attribute on slides)
   *   2. Fallback: match by featured_image_src (compare against slide image URLs)
   *
   * @param {Object} variant - The selected variant object (from JSON)
   */
  function updateImageSlider(variant) {
    var mainSwiperElement = container.querySelector(
      ".mc-main-product__image-slider--main",
    );
    if (!mainSwiperElement || !mainSwiperElement._swiperInstance) return;

    var swiperInstance = mainSwiperElement._swiperInstance;
    var slides = mainSwiperElement.querySelectorAll(".swiper-slide");
    var targetIndex = -1;

    // Strategy 1: Match by featured_media_id
    if (variant.featured_media_id) {
      for (var i = 0; i < slides.length; i++) {
        if (
          slides[i].getAttribute("data-media-id") == variant.featured_media_id
        ) {
          targetIndex = i;
          break;
        }
      }
    }

    // Strategy 2: Fallback to matching by image src
    if (targetIndex === -1 && variant.featured_image_src) {
      // Extract the file path portion from the variant image src for comparison
      // Shopify image URLs can have different CDN prefixes and size suffixes
      var variantImageFile = extractImageFilename(variant.featured_image_src);

      if (variantImageFile) {
        for (var j = 0; j < slides.length; j++) {
          var slideImg = slides[j].querySelector("img");
          if (slideImg && slideImg.src) {
            var slideImageFile = extractImageFilename(slideImg.src);
            if (slideImageFile && slideImageFile === variantImageFile) {
              targetIndex = j;
              break;
            }
          }
        }
      }
    }

    // Slide to the matched index if found
    if (targetIndex !== -1) {
      swiperInstance.slideTo(targetIndex);
    }
  }

  /**
   * Extracts the core filename from a Shopify CDN image URL.
   * Strips size suffixes like _100x, _5000x5000 etc. for clean comparison.
   * Example: ".../my-image_100x.jpg" -> "my-image.jpg"
   * @param {string} url - Full image URL
   * @returns {string|null} The extracted filename, or null if extraction fails
   */
  function extractImageFilename(url) {
    if (!url) return null;
    try {
      // Get the pathname and then the filename
      var pathname = new URL(url, window.location.origin).pathname;
      var filename = pathname.split("/").pop();
      // Remove Shopify size suffixes like _100x, _5000x5000, _grande, etc.
      return filename.replace(
        /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.|$)/g,
        "$2",
      );
    } catch (e) {
      return null;
    }
  }

  /**
   * Formats money without trailing zeros (.00)
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatMoneyWithoutTrailingZeros(cents) {
    var formatted = Shopify.formatMoney(cents);
    return formatted.replace(".00", "");
  }
}

/**
 * Initializes Shopify money formatting with store currency settings
 */
function initializeShopifyFormatMoney() {
  if (!window.Shopify) {
    window.Shopify = {};
  }

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
}
